import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute } from '@angular/router';
import { OnDemandService } from '../../../services/ondemand.service';
import { OnDemandVideoFolderVM } from "../../../models";

@Component({
  selector: 'account-ondemand',
  templateUrl: './ondemand.component.html'
})

export class OnDemandComponent extends BaseComponent implements OnInit {

  model: Array<OnDemandVideoFolderVM>;
  currentFolder: "";
  constructor(
    private route: ActivatedRoute,
    private ondemandService: OnDemandService
  ) {
    super(route);
  }

  ngOnInit(): void {
    this.emitDisplayLoadingDialog(true);
    this.ondemandService.getVideos()
      .subscribe(
        returnValue => {
          this.model = returnValue;
        },
        e => e,
        () => {
          this.emitDisplayLoadingDialog(false);
        }
      );
  }

  setFolder(folder): void {
    if (this.currentFolder == folder) {
      this.currentFolder = "";
    }
    else {
      this.currentFolder = folder;
    }
  }

  testTsCall(vid): void {
    const seconds = vid.target.duration;
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    // Format the time components as two-digit numbers
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = remainingSeconds.toString().padStart(2, '0');
    let result = '';

    if (hours > 0) {
      result = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    } else {
      result = `${formattedMinutes}:${formattedSeconds}`;
    }

    vid.target.nextSibling.innerHTML += `<span style="float:right;color:#ff2500;font-weight:bold;">${result}</span>`;
  }
}
